import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PurchaseConfirmationComponent } from './purchase-confirmation.component';

@NgModule({
  declarations: [
    PurchaseConfirmationComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [],
  providers: []
})
export class PurchaseConfirmationModule {}
